angular.module('callX').controller('ContactsPageCtrl', ['$scope','$stateParams','UserService','$rootScope', '$state', 'toaster', function($scope,$stateParams,UserService, $rootScope,$state, toaster) {
    
    var username_agent = $stateParams.username;
    var userId = $stateParams.userId;
    $scope.role ;
    $scope.getuserRole ;
    $scope.getsalesRole ;

    $scope.searchPage = false;
    $scope.tableContentLoading=false; 
    $scope.tableContentLoadingSearch=false;

    $scope.setAgentFirsAandLastName = function() {
        $scope.username_firstName = window.localStorage.getItem("first_name")
        $scope.username_lastName = window.localStorage.getItem("last_name")
        $scope.user_name = window.localStorage.getItem("user_name")
        $scope.user_id = window.localStorage.getItem("user_id")
        $scope.role = window.localStorage.getItem("role")
        if ($scope.role === 'AGENT') {
            $scope.role = 'salesagent';
        }
        $scope.email = window.localStorage.getItem("email")
        if($scope.role == 'useragent'){
            $scope.getuserRole = $scope.role;
            $scope.getAgentStats();
        }else if($scope.role == 'salesagent'){
            $scope.getsalesRole = $scope.role;
            $scope.getsalesAgentStats();
        }
    }

    $scope.limitTextLength = function(text) {
        return text.slice(0,4) + '..'
    }

    $scope.setAgentFirsAandLastName();

   
    // $scope.newPage =  false;
    $scope.rootDispositionsArray = [];
    $scope.dispositionsArray = [];
    $scope.contactsPageData=[];

    $scope.currentPage = 0; 
    $scope.itemsPerPage = 20;
    $scope.maxSize = 3;

    $scope.agentContactsPage = function(){
        $scope.tableContentLoading = true;
        $rootScope.currentPage = 'contactpage';
        $state.go('app.sales-agent.contacts', { username: $scope.user_name, userId: $scope.user_id });

        var callbacks = {
        success: function(data) {
            // console.log(data, "get contact data")
           $scope.contactsData = data.data;
           $scope.contactsPageData = data.data.sales_agent_contact_list; 
           $scope.totalPages = data.data.total_pages;
           $scope.totalItems = data.data.total_records;

           $scope.rootDispositionsArray = data.data.root_disposition.map(function(disposition) {
                return disposition === null ? "N/A" : disposition;
           });
           $scope.dispositionsArray = data.data.disposition.map(function(disposition) {
                return disposition === null ? "N/A" : disposition;
           });

           $scope.tableContentLoading = false;
            },
        failure: function(data) {
            $scope.tableContentLoading = false;
            }
        };
        UserService.getContactsPage($scope.user_id,$scope.currentPage,$scope.itemsPerPage,callbacks); 
    } 

    $scope.agentContactsPage(); 

    $scope.pageChanged = function() {
        // console.log($scope.currentPage,$scope.itemsPerPage, "inisde page change ")
        var callbacks = {
        success: function(data) {
                // console.log(data, "pagination contacts -----")
                $scope.contactsPageData = data.data.sales_agent_contact_list;
                $scope.totalPages = data.data.total_pages;
                $scope.totalItems = data.data.total_records;

                $scope.rootDispositionsArray = data.data.root_disposition.map(function(disposition) {
                     return disposition === null ? "N/A" : disposition;
                });
                $scope.dispositionsArray = data.data.disposition.map(function(disposition) {
                     return disposition === null ? "N/A" : disposition;
                }); 

                $scope.tableContentLoading = false;
            },
        failure: function(data) {
            $scope.tableContentLoading = false;
            }
        }; 
        UserService.getContactsPage($scope.user_id,$scope.currentPage-1,$scope.itemsPerPage,callbacks); 
    }

    $scope.formatPhoneNumber = function(phoneNumber) {
        phoneNumber = phoneNumber.replace(/^1|^91/, '');
        var formattedPhoneNumber = phoneNumber.replace(/(\d{3})(\d{3})(\d{4})/, '($1) $2-$3');
        return formattedPhoneNumber;
    }; 

      //calendar starts  
      $scope.dpOpened1 = false;
 
      $scope.open = function($event) {
          $event.preventDefault();
          $event.stopPropagation();
          $scope.dpOpened1 = !$scope.dpOpened1;
      };
   
      $scope.dateOptions = {
          formatYear: 'yyyy',
          startingDay: 0,
          class: 'datepicker',
          showWeeks:false
      };
   
      $scope.format = 'MM/dd/yyyy';
   
      $scope.$watch('$scope.submitted_date', function (newDate) {
            if(newDate){
                // console.log(newDate, "get new date")
                $scope.submitted_date = moment($scope.submitted_date).format("MM/dd/yyyy");
            }
        }); 
  
    //   $scope.today = function() {
    //       $scope.getDate = new Date();
    //   };
    //   $scope.today();
    $scope.toggleMin = function() {
        $scope.minDate = new Date(); 
    };
    $scope.toggleMin();
  
      $scope.openDatePicker = function($event) {
        //   console.log("open date")
          $event.preventDefault();
          $event.stopPropagation();
          $scope.openedTo = false;
          $scope.openedFrom = true;
      };
  
      $scope.dateOptionsDatePicker = {
          formatYear: 'yy',
          startingDay: 0,
          class: 'datepicker',
          showWeeks:false
      };
      //calendar ends

      function formatPhoneNumberFormat(phoneNumber) {
        const cleanedNumber = phoneNumber.replace(/[^\d]/g, '');
        return '1' + cleanedNumber; // Append '1' before the cleaned number
    }

    $scope.formatDateToYYYYMMDD = function(val) {
        var date = new Date(val);
        if (typeof val === 'string' && val.match(/^\d{2}\/\d{2}\/\d{4}$/)) {
            var parts = val.split('/');
            var day = parseInt(parts[0], 10);
            var month = parseInt(parts[1], 10) - 1; // month is 0-based in JS Date
            var year = parseInt(parts[2], 10);
    
            // Create a Date object with the parsed values
            date = new Date(year, month, day);
        }
        var year = date.getFullYear();
        var month = String(date.getMonth() + 1); 
        var day = String(date.getDate());
        month = month.length === 1 ? '0' + month : month;
        day = day.length === 1 ? '0' + day : day;
        return year + '-' + month + '-' + day + " " + '00:00:00';
        // return day + '/' + month + '/' + year + " " + '00:00:00';
    }

     // filter records 
     $scope.filterContactRecords = function(currentSearchNumber) {
        var filtersContactObject = { 
            filters:[]
         };
         $scope.searchPage = true;
         $scope.tableContentLoadingSearch = true;
       
        // Filter by name or phone number
        if ($scope.userNameOrPhone) {
            var input = $scope.userNameOrPhone.trim();
    
            // Check if the input is a number (phone number)
            if (/^(?:\(\d{3}\)\s?|\d{3}-)\d{3}-\d{4}$/.test(input) || /^\d+$/.test(input)) {
                filtersContactObject.filters.push({
                    key: "phoneNumber",
                    operation: "contains",
                    value: formatPhoneNumberFormat(input)
                });
            } else {
                filtersContactObject.filters.push({
                    key: "name",
                    operation: "contains",
                    value: input
                });
            }
        }

        // Set ref_from property to $scope.getDate value
        // if ($scope.getDate) {
        //     filtersContactObject.ref_from = $scope.getDate;
        // }

        if ($scope.submitted_date) {
            var getCreatedAt = {
                "key": "contactCreatedAt",
                "operation": "=",
                "value":  $scope.formatDateToYYYYMMDD($scope.submitted_date)
            };
            filtersContactObject.filters.push(getCreatedAt);
        }
    
        // pass salesagentId 
        if ($scope.user_id) {
            var salesUserId = {
                "key": "salesAgentId",
                "operation": "=",
                "value": $scope.user_id
            };
            filtersContactObject.filters.push(salesUserId);
        }

        // Check if rootDisposition has a value selected
        if ($scope.rootDisposition) {
            var rootDispositionFilter = {
                key: "rootDisposition",
                operation: "equals", 
                value: $scope.rootDisposition
            };
            filtersContactObject.filters.push(rootDispositionFilter);
        }
    
        // Check if disposition has a value selected
        if ($scope.disposition) {
            var dispositionFilter = {
                key: "disposition", 
                operation: "equals", 
                value: $scope.disposition
            };
            // Push the filter object into the filters array
            filtersContactObject.filters.push(dispositionFilter);
        }

        $scope.itemsSearchPerPage = 20;
        $scope.maxSearchSize = 3;

        if(currentSearchNumber){
            $scope.currentSearchPage = currentSearchNumber;
        }else{
            $scope.currentSearchPage = 0;
        }

        if($scope.currentSearchPage > 0){
            filtersContactObject.page = $scope.currentSearchPage - 1;
        }else {
            filtersContactObject.page = $scope.currentSearchPage;
        }

        filtersContactObject.size = $scope.itemsSearchPerPage;

            var callbacks = {
                success: function(data) {
                    // console.log("log search data contact ---------", data)
                    $scope.contactsPageData = data.data.sales_agent_contacts;
                    $scope.totalSearchPages = data.data.total_pages;
                    $scope.totalSearchItems = data.data.total_records;
                    // console.log($scope.contactsPageData,$scope.totalSearchPages,$scope.totalSearchItems, "search data")

                    $scope.tableContentLoadingSearch = false;
                },
                failure: function(data) {
                    $scope.tableContentLoadingSearch = false;
                }
            };
            UserService.contactPageReportsData(filtersContactObject, callbacks);
    }; 

    $scope.pageChangedSearch = function(){
        $scope.filterContactRecords($scope.currentSearchPage)
    }

    // reset filters 
    $scope.resetContactFilters = function() {
        $scope.userNameOrPhone = ''; 
        $scope.submitted_date = '';
        $scope.rootDisposition = ''; 
        $scope.disposition = '';
        $scope.searchPage = false;
        $scope.agentContactsPage();
        // $scope.pageChanged ();  
    };
    
    $scope.contactDetailsPage = function(firstname, lastname, phone_number){
        var contactName = firstname + ' ' + lastname;
        $scope.contactDetails = true;
        $state.go('app.sales-agent.details', { contactName: contactName, phoneNumber:phone_number});
    } 

    // $scope.formatTime = function(timeString) {
    //     var formattedTime;
    //     if (timeString) {
    //         var parts = timeString.split(' ');
    //         var dateParts = parts[0].split('-');
    //         var timeParts = parts[1].split(':');
    //         formattedTime = (dateParts[1] + '/' + dateParts[2] + '/' + dateParts[0].slice(-2)) + ', ' + timeParts[0] + ':' + timeParts[1];
    //     } else {
    //         formattedTime = '-';
    //     }
    //     return formattedTime;
    // }; 

    // $scope.formatTime = function(timeString) {
    //     var formattedTime;
    //     if (timeString) {
    //         var parts = timeString.split(' ');
    //         var dateParts = parts[0].split('-');
    //         var timeParts = parts[1].split(':');
            
    //         var hours = parseInt(timeParts[0], 10);
    //         var minutes = timeParts[1];
    //         var period = hours >= 12 ? 'PM' : 'AM';

    //         hours = (hours % 12 || 12).toString().padStart(2, '0');
    //         minutes = minutes.padStart(2, '0');
    
    //         formattedTime = (dateParts[1] + '/' + dateParts[2] + '/' + dateParts[0].slice(-2)) + ', ' + hours + ':' + minutes + ' ' + period;
    //     } else {
    //         formattedTime = '-';
    //     }
    //     return formattedTime;
    // };

    $scope.formatTime = function(timeString) {
        var formattedTime;
        if (timeString) {
            // Parse the input time string
            var parts = timeString.split(' ');
            var dateParts = parts[0].split('-');
            var timeParts = parts[1].split(':');
    
            // Create a Date object from the UTC time
            var utcDate = new Date(Date.UTC(
                parseInt(dateParts[0], 10),  // Year
                parseInt(dateParts[1], 10) - 1,  // Month (0-based)
                parseInt(dateParts[2], 10),  // Day
                parseInt(timeParts[0], 10),  // Hour
                parseInt(timeParts[1], 10)   // Minute
            ));
    
            // Convert UTC to PST (UTC-8)
            // For PDT (UTC-7), adjust the offset accordingly
            var pstDate = new Date(utcDate.getTime() - (7 * 60 * 60 * 1000));
    
            // Format the date to the desired format
            var hours = pstDate.getUTCHours();
            var minutes = pstDate.getUTCMinutes();
            var period = hours >= 12 ? 'PM' : 'AM';
    
            hours = (hours % 12 || 12).toString().padStart(2, '0');
            minutes = minutes.toString().padStart(2, '0');
            var month = (pstDate.getUTCMonth() + 1).toString().padStart(2, '0');
            var day = pstDate.getUTCDate().toString().padStart(2, '0');
    
            formattedTime = month + '/' + day + '/' + pstDate.getUTCFullYear().toString().slice(-2) + ', ' + hours + ':' + minutes + ' ' + period;
        } else {
            formattedTime = '-';
        }
        return formattedTime;
    };

      $scope.getName = function(firstname, lastname) {
        if (firstname && lastname) {
            return firstname + ' ' + lastname;
        } else if (firstname) {
            return firstname;
        } else if (lastname) {
            return lastname;
        } else {
            return 'Unknown Contact';
        }
    };
    

  }]);